import React, { useState, useEffect } from 'react';

const CookieConsent = () => {
  const [visible, setVisible] = useState(false);
  const [choice, setChoice] = useState(null);

  useEffect(() => {
    const stored = localStorage.getItem('cookieConsent');
    if (!stored) setVisible(true);
    else setChoice(stored);
  }, []);

  const handleAccept = () => {
    localStorage.setItem('cookieConsent', 'accepted');
    setChoice('accepted');
    setVisible(false);
  };

  const handleReject = () => {
    localStorage.setItem('cookieConsent', 'rejected');
    setChoice('rejected');
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div className="fixed bottom-0 left-0 right-0 z-50 bg-surface border-t border-border shadow-lg p-4 flex flex-col sm:flex-row items-center justify-between gap-4 animate-fade-in">
      <div className="flex-1 text-text-secondary text-sm">
        We use cookies to enhance your experience. By clicking "Accept", you consent to the use of cookies. <a href="/privacy-policy" className="text-primary underline">Learn more</a>.
      </div>
      <div className="flex gap-2">
        <button
          onClick={handleAccept}
          className="px-4 py-2 rounded bg-primary text-white font-medium hover:bg-primary/90 transition"
        >
          Accept
        </button>
        <button
          onClick={handleReject}
          className="px-4 py-2 rounded bg-surface border border-border text-text-primary font-medium hover:bg-surface-secondary transition"
        >
          Reject
        </button>
      </div>
    </div>
  );
};

export default CookieConsent; 